export interface Message {
  type: MessageType;
  action: MessageAction;
  payload: any;
  subscription_id?: string;
}

export enum MessageType {
  ANALYTICS = 'ANALYTICS',
  FIGHT_SCORE = 'FIGHT_SCORE',
  GAME_ANALYTICS = 'GAME_ANALYTICS',
  HEARTBEAT = 'HEARTBEAT',
  MINING = 'MINING',
  SCREENTIME = 'SCREENTIME',
  SIGNIN = 'SIGNIN',
  WALLET = 'WALLET',
}

export enum MessageAction {
  EXECUTE = 'EXECUTE',
  NOTIFICATION = 'NOTIFICATION',
  // Response
  STATUS = 'STATUS',

  // Request
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
}

export type CbType = (data: Message) => any;
